var _excluded = ["className", "rowHeight", "rowInfo", "coverLeft", "coverRight", "rowClassName", "onRow"],
    _excluded2 = ["rowHeight"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { memo, Fragment, useMemo } from 'react';
import { classnames, createArray, isNumber, isAssigned, isFunction } from '@okee-uikit/react-utils';
import { useDirection, usePrefixCls } from '@okee-uikit/react-config';
import { RightOne } from '../../common/icons';
import { useCell, useRow } from '../../hooks/table';
import { useTableExpansion, useTableTree } from '../table/hooks/active';
import { selectionColumnId, useTableSelection } from '../table/hooks/selection';
import { useTableTheme } from './hooks/useTableTheme';
import { TableColumnRender } from './TableColumnRender';
export var TableRow = memo(function (props) {
  return React.createElement(TableRowRender, _objectSpread({}, props));
});
export function TableRowRender(props) {
  var className = props.className,
      propRowHeight = props.rowHeight,
      propRowInfo = props.rowInfo,
      coverLeft = props.coverLeft,
      coverRight = props.coverRight,
      rowClassName = props.rowClassName,
      onRow = props.onRow,
      extra = _objectWithoutProperties(props, _excluded);

  var _useTableTree = useTableTree(),
      treeActive = _useTableTree.active,
      treeActions = _useTableTree.actions;

  var tree = useMemo(function () {
    if (!treeActions) {
      return undefined;
    }

    var path = propRowInfo.path;
    var activeInfo = {
      active: treeActions.isActive(path),
      activate: function activate() {
        return treeActions.activate(path);
      },
      inactivate: function inactivate() {
        return treeActions.inactivate(path);
      },
      toggle: function toggle() {
        return treeActions.toggle(path);
      }
    };
    return activeInfo;
  }, [propRowInfo, treeActive, treeActions]);

  var _useTableExpansion = useTableExpansion(),
      expansionActive = _useTableExpansion.active,
      expansionActions = _useTableExpansion.actions;

  var expansion = useMemo(function () {
    if (!expansionActions) {
      return undefined;
    }

    var id = propRowInfo.id;
    var activeInfo = {
      active: expansionActions.isActive(id),
      activate: function activate() {
        return expansionActions.activate(id);
      },
      inactivate: function inactivate() {
        return expansionActions.inactivate(id);
      },
      toggle: function toggle() {
        return expansionActions.toggle(id);
      }
    };
    return activeInfo;
  }, [propRowInfo, expansionActive, expansionActions]);

  var _useTableSelection = useTableSelection(),
      selected = _useTableSelection.selected,
      selectionActions = _useTableSelection.actions;

  var selection = useMemo(function () {
    if (!selectionActions) {
      return undefined;
    }

    var id = propRowInfo.id;
    var selectionInfo = {
      selected: selectionActions.isSelected(id),
      select: function select() {
        return selectionActions.select(id);
      },
      unselect: function unselect() {
        return selectionActions.unselect(id);
      },
      toggle: function toggle() {
        return selectionActions.toggle(id);
      }
    };
    return selectionInfo;
  }, [propRowInfo, selected, selectionActions]);
  var rowInfo = useMemo(function () {
    return _objectSpread(_objectSpread({}, propRowInfo), {}, {
      tree: tree,
      expansion: expansion,
      selection: selection
    });
  }, [propRowInfo, tree, expansion, selection]);
  var row = rowInfo.row,
      path = rowInfo.path,
      index = rowInfo.index,
      level = rowInfo.level,
      children = rowInfo.children;
  var key = path.join('-');

  var _useTableTheme = useTableTheme(),
      themRowHeight = _useTableTheme.rowHeight;

  var _ref = onRow && onRow(row) || {},
      _ref$rowHeight = _ref.rowHeight,
      rowHeight = _ref$rowHeight === void 0 ? propRowHeight !== null && propRowHeight !== void 0 ? propRowHeight : themRowHeight : _ref$rowHeight,
      rowAttrs = _objectWithoutProperties(_ref, _excluded2);

  var clsExtra = isFunction(rowClassName) ? rowClassName(row, index) : rowClassName;
  var cls = classnames(usePrefixCls('table-row', {
    child: level > 1
  }), className, clsExtra);
  var clsTreeEmpty = usePrefixCls('table-tree-empty');
  var clsExpansion = usePrefixCls('table-row-expansion');

  var _useMemo = useMemo(function () {
    if (!tree) {
      return [undefined, undefined];
    }

    var trigger = treeActions.trigger ? treeActions.trigger(_objectSpread(_objectSpread({}, rowInfo), tree)) : React.createElement(TableActiveTrigger, {
      key: "TreeTrigger",
      rowInfo: rowInfo,
      activeInfo: tree,
      indent: treeActions.indent,
      placeholder: !children
    });
    return [trigger, undefined];
  }, [rowInfo]),
      _useMemo2 = _slicedToArray(_useMemo, 1),
      treeTrigger = _useMemo2[0];

  var _useMemo3 = useMemo(function () {
    if (level !== 1 || !expansion) {
      return [undefined, undefined];
    }

    var trigger = expansionActions.trigger ? expansionActions.trigger(_objectSpread(_objectSpread({}, rowInfo), expansion)) : React.createElement(TableActiveTrigger, {
      key: "ExpansionTrigger",
      rowInfo: rowInfo,
      activeInfo: expansion,
      indent: 0
    });
    return [trigger, undefined];
  }, [rowInfo, expansionActive, expansionActions]),
      _useMemo4 = _slicedToArray(_useMemo3, 1),
      expansionTrigger = _useMemo4[0];

  var _useRow = useRow(row),
      nonFixedColumns = _useRow.nonFixedColumns,
      fixedLeftColumns = _useRow.fixedLeftColumns,
      fixedRightColumns = _useRow.fixedRightColumns;

  var firstColumn = fixedLeftColumns.find(function (col) {
    return col !== selectionColumnId;
  }) || nonFixedColumns.find(function (col) {
    return col !== selectionColumnId;
  });

  var renderColumns = function renderColumns(columns) {
    return columns.map(function (column) {
      var start = [];

      if (column === firstColumn) {
        start.push(treeTrigger);
        start.push(expansionTrigger);
      }

      return React.createElement(Cell, {
        key: column,
        column: column,
        height: rowHeight,
        rowInfo: rowInfo,
        start: start
      });
    });
  };

  var content = [React.createElement(TableColumnRender, _objectSpread(_objectSpread(_objectSpread({}, extra), rowAttrs), {}, {
    key: "Row-".concat(key),
    className: cls,
    height: rowHeight,
    fixedLeft: renderColumns(fixedLeftColumns),
    fixedRight: renderColumns(fixedRightColumns),
    nonFixed: renderColumns(nonFixedColumns),
    coverLeft: coverLeft,
    coverRight: coverRight
  }))];

  if (treeActions && tree && tree.active && children) {
    var empty = treeActions.empty;
    children.forEach(function (childRowInfo) {
      content.push(React.createElement(TableRowRender, {
        key: "Row-".concat(childRowInfo.path.join('-')),
        rowInfo: childRowInfo,
        coverLeft: coverLeft,
        coverRight: coverRight,
        rowClassName: rowClassName,
        onRow: onRow
      }));
    });

    if (children.length === 0 && empty) {
      content.push(React.createElement("div", {
        key: "TreeEmpty-".concat(key),
        className: clsTreeEmpty
      }, isFunction(empty) ? empty(_objectSpread(_objectSpread({}, rowInfo), tree)) : empty));
    }
  }

  if (expansionActions && expansion && expansion.active) {
    content.push(React.createElement("div", {
      key: "RowExpansion-".concat(key),
      className: clsExpansion
    }, expansionActions.content(_objectSpread(_objectSpread({}, rowInfo), expansion))));
  }

  return React.createElement(Fragment, null, content);
}

function TableActiveTrigger(props) {
  var rtl = useDirection() === 'rtl';
  var rowInfo = props.rowInfo,
      activeInfo = props.activeInfo,
      indent = props.indent,
      placeholder = props.placeholder;
  var cls = usePrefixCls('table-active-trigger', {
    rtl: rtl,
    active: activeInfo.active
  });
  var clsIndent = usePrefixCls('table-active-trigger-indent');
  var clsIcon = usePrefixCls('table-active-trigger-icon');
  var indentStyle = isAssigned(indent) && {
    width: indent && isNumber(indent) && "".concat(indent, "px") || indent
  } || undefined;
  var level = rowInfo.level;
  var toggle = activeInfo.toggle;
  return React.createElement("button", {
    className: cls,
    disabled: placeholder,
    onClick: toggle
  }, level > 1 && indent !== 0 && React.createElement("i", {
    key: "indent",
    className: clsIndent
  }, createArray(level - 1, function (i) {
    return React.createElement("i", {
      key: i,
      style: indentStyle
    });
  })), placeholder && React.createElement("i", {
    key: "placeholder",
    className: clsIcon
  }) || React.createElement(RightOne, {
    key: "icon",
    className: clsIcon
  }));
}

function Cell(props) {
  var column = props.column,
      height = props.height,
      rowInfo = props.rowInfo,
      start = props.start,
      end = props.end;

  var _useCell = useCell(column),
      renderData = _useCell.renderData,
      className = _useCell.className,
      width = _useCell.width,
      isFirstShownColumn = _useCell.isFirstShownColumn,
      isLastShownColumn = _useCell.isLastShownColumn;

  var row = rowInfo.row;
  var cls = classnames(usePrefixCls('table-cell', {
    body: true,
    first: isFirstShownColumn,
    last: isLastShownColumn
  }), className);
  return React.createElement("div", {
    className: cls,
    style: {
      height: "".concat(height, "px"),
      width: "".concat(width, "px")
    }
  }, renderData(row, rowInfo, start, end));
}